<template>
  <vx-card>
    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button v-if="isAdmin" class="mr-2" color="secondary" @click="handleClickDelete">삭제</vs-button>
        <vs-button class="mr-2" color="secondary" type="border" @click="back">목록</vs-button>
        <vs-button class="" color="secondary" @click="register">등록</vs-button>
      </vs-col>
    </vs-row>

    <div >
      <div>
        <h5 class="mb-4"><i class="dot"></i>팝업 내용</h5>
      </div>
      <vs-row class="mb-8">
        <vs-col class="flex flex-wrap" style="column-gap: 1rem;">
          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 129px 1fr;">
            <vs-col>종류</vs-col>
            <vs-col>
              <vs-select autocomplete v-model="form.noticeName" disabled="disabled">
                <vs-select-item text="공지사항" value="공지사항" />
              </vs-select>
            </vs-col>
          </vs-row>
          <div class="mb-4 grid items-center" style="grid-template-columns: 129px 1fr;">
            <vs-col >제목</vs-col>
            <vs-col style="width: 40vw;">
              <ml-input class="w-full" v-model="form.title"/>
            </vs-col>
          </div>
          <div class="mb-4 grid items-center" style="grid-template-columns: 129px 1fr;">
            <vs-col >작성자</vs-col>
            <vs-col>
              <ml-input class="w-full" v-model="form.writer" :readonly="true"/>
            </vs-col>
          </div>

          <vs-row class="w-full mb-4 grid" vs-justify="center" style="grid-template-columns: 129px 1fr;">
            <vs-col style="line-height: 2.5rem;">내용</vs-col>
            <vs-col vs-align="center" >
              <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
            </vs-col>
          </vs-row>

          <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 129px 1fr;">
            <vs-col>팝업 노출 여부</vs-col>
            <vs-col>
              <vs-switch v-model="form.open" color="success" />
            </vs-col>
          </vs-row>

          <vs-row v-if="form.open"
                  class="w-full mb-4 grid"  vs-justify="center" style="grid-template-columns: 129px 1fr;">
            <vs-col class="items-start" style="line-height: 2.5rem;">팝업 세부 설정</vs-col>
            <vs-col class="modal-option" vs-align="center">
              <div class="modal-option_item">
                <label>시작일</label><date-selector v-model="form.options.beginDate"/>
                <span class="mx-3">~</span>
                <label>종료일</label><date-selector v-model="form.options.endDate"/>
              </div>
              <div class="modal-option_item" style="line-height: 2.65rem;">
                <vs-radio v-model="form.options.skipDate" vs-value="1">오늘 하루 보지 않기</vs-radio>
                <vs-radio v-model="form.options.skipDate" vs-value="7">7일간 보지 않기</vs-radio>
              </div>
            </vs-col>
          </vs-row>

        </vs-col>
      </vs-row>
    </div>


  </vx-card>
</template>

<script>

import FileUploadModule from '@/views/modules/FileUploadModule'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import DateSelector from "@/components/selector/DateSelector.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  name: 'CommunityBusinesssnewsCreate',
  components: {
    DateSelector,
    FileUploadModule,
    quillEditor
  },
  data () {
    return {
      boardSlug: 'board-612',
      boardId: 612,

      quillOption: {
        placeholder: '내용을 입력해주세요'
      },
      form: {
        noticeName: '공지사항', //공지사항종류
        title: '', //제목
        writer: this.$store.state.auth.userInfo.name, //작성자
        content: '',
        open: false,
        options: {
          beginDate: `${new Date().getFullYear()}-01-01`,
          endDate: `${new Date().getFullYear()}-12-31`,
          skipDate: '1',
        },
      },
    }
  },

  computed: {
    postId() {
      return this.$route.params.postId;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
  },

  created () {
    this.loadPost()
  },

  methods:{
    back () {
      this.$router.back()
    },

    async handleClickDelete() {
      if (await UiUtil.confirmDialog("문서를 삭제하시겠습니까?")) {
        const project_id = parseInt(this.$route.params.proj_id);
        const boardId = this.boardId;
        const postId = this.postId;
        this.$store.dispatch("board/DELETE_POST", { boardId, postId }).then((value) => {
          if (project_id) {
            this.$router.push({ path: `/project/${project_id}/community/popup-notice/` });
          } else {
            this.$router.push({ path: "/community/popup-notice/" });
          }
        });
      }
    },


    async loadPost () {
      const boardId = this.boardId
      const postId = this.postId
      await this.$store.dispatch('board/LOAD_POST', {boardId, postId})

      // 내용
      const post = this.$store.state.board.postInfo
      console.log("post", post)
      this.form = JSON.parse(post.post_content).body
    },

    async register () {
      const postId = this.postId
      const boardId = this.boardId
      const title = this.form.title

      this.form.parentId = 0
      const content = JSON.stringify({
        header: {
          full: new Date().format("yyyy-MM-dd"),
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
        body: this.form
      })

      if (this.formCheck()) {
        await this.$store.dispatch('board/UPDATE_POST', {
          boardId,
          postId,
          title,
          content
        })

        this.$router.back()
      }

    },

    formCheck () {
      if (this.form.title.trim().length <= 0) {
        UiUtil.alertDialog('제목을 입력해주세요')
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-option {
  display: grid;
  row-gap: 1rem;
  .modal-option_item {
    label { margin-right: 1rem; }
  }
}
</style>
<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
